export const capitalizeFirstLetter = ([first, ...rest]) =>
	first.toUpperCase() + rest.join('').toLowerCase();

export const capitalize = str =>
	str
		.split(' ')
		.map(s => capitalizeFirstLetter(s))
		.join(' ');
